function makeSafeOperation(_ref) {
  var getOperation = _ref.getOperation,
      operationAvailable = _ref.operationAvailable;
  var payloadQueue = [];
  var operation;
  operationAvailable.then(function () {
    operation = getOperation();
    payloadQueue.forEach(function (payload) {
      return operation(payload);
    });
    payloadQueue = [];
  });
  return function (payload) {
    if (operation) {
      operation(payload);
    } else {
      payloadQueue.push(payload);
    }
  };
}

export default makeSafeOperation;